import {ApplicationInsights} from "@microsoft/applicationinsights-web"
import {ReactPlugin} from "@microsoft/applicationinsights-react-js"

const reactPlugin = new ReactPlugin()

const isLocal = process.env.REACT_APP_LOCAL === "true"
const defaultConnectionString =
  "InstrumentationKey=xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
const connectionString = isLocal
  ? defaultConnectionString
  : (window as any).DeliverablesConfig.appInsightsConnectionString
const appInsights = new ApplicationInsights({
  config: {
    connectionString: connectionString || defaultConnectionString,
    //@ts-ignore
    extensions: [reactPlugin],
    extensionConfig: {
      // below config was added to avoid "https://js.monitor.azure.com/scripts/b/ai.config.1.cfg.json" errors
      // issue - https://github.com/microsoft/ApplicationInsights-JS/issues/2341
      ["AppInsightsCfgSyncPlugin"]: {
        cfgUrl: ""
      },},
    disableFetchTracking: true,
    disableExceptionTracking: false,
    disableDataLossAnalysis: false,
    disableTelemetry: false,
    disableAjaxTracking: true,
  },
})

appInsights.loadAppInsights()

export {appInsights, reactPlugin}
